import {customElement, bindable, autoinject, containerless, computedFrom } from "aurelia-framework";
import {EditableInputElementService, IEditableInlineEditor} from "../editable-input-element-service";
import { ICalendarConfiguration } from "../../../services/formSchema/form-schema-service";
import { DateService, IFormatParameters  } from "../../../services/date-service";
import "./editable-inline-calendar.css";
import { DatePicker} from "../bootstrap-datepicker/datepicker";
/**
 * This custom element wraps and controls the textbox that is used for editing a field when the
 * editable-inline attribute is applied to an input element.  It can be used across multiple input elements.
 */
@containerless
@autoinject
export class EditableInlineCalendar implements IEditableInlineEditor {

    private calendar: Element;
    private datepicker_vm: DatePicker;
    // @bindable
    // classEx: string | null = null;

    constructor(
        private editableInputElementService: EditableInputElementService
        , private dateService: DateService
    ) {
    }

    private onSave: () => void;
    private onKeyPress: (event: KeyboardEvent) => boolean;
    value: string;
    format: string;

    bind() {
        this.editableInputElementService.editor = $(this.calendar);
        //if (this.classEx) {
        //    this.editableInputElementService.editor.addClass(this.classEx);
        //}        
    }

    //@computedFrom("value")
    //get valueFormatted(): string {
    //    return this.dateService.toString(this.value, "table");
    //}
    //set valueFormatted(val: string) {
    //    this.value = this.dateService.fromString(val, "table");
    //}

    /**
     * 
     * @param element
     * @param onKeyPress called on any keypress
     * @param onSave -- called on blur
     */
    public show(element: JQuery, config: ICalendarConfiguration, currentValue: string, onKeyPress: any, onSave: any ): void {

        this.editableInputElementService._show(element);

        // tell the calendar what format it is in
        this.format = config ? config.DisplayFormat || 'table' : 'table';

        // is already in displayFormat  
        this.value = currentValue; // this.dateService.convertFormat(currentValue, config.ViewmodelFormat,  config.DisplayFormat);

        this.onSave = onSave;
        this.onKeyPress = onKeyPress;

        setTimeout(() => this.datepicker_vm.show(), 0);
    }

    onDropdownHide(viewmodel: DatePicker): void {
        this.onSave();
    }

    onKeydown(event: KeyboardEvent, viewmodel: DatePicker): boolean {
        return this.onKeyPress(event);
    }

    public hide(): void {

        this.datepicker_vm.hide();
        this.editableInputElementService._hide();
    }

    //private _dateValue: Date;

    //@computedFrom("_dateValue")
    //public get value(): Date {
    //    return this._dateValue;
    //}

    //public set value(date: Date) {
    //    this._dateValue = date;
    //}
 
    public get maxLength(): number {
        return this.editableInputElementService.maxLength;
    }

    detached() {
        this.editableInputElementService.detached();
    }

    attached() {
        this.editableInputElementService.attached();
    }

}
